export default __webpack_public_path__ + "static/media/SHIB.47bff98c.png";